export const useProducts = () => {

    const getProductsList = async (): Promise<Product[]> => {

            const products: Product[] = await $fetch(`/api/products/getlist`, {
                method: 'GET',
            })

            return products;
    }

    return {getProductsList}
}